type InvoiceUiEvent =
  | 'invoice_drawer_opened'
  | 'invoice_action_finalize'
  | 'invoice_action_send'
  | 'invoice_action_void'
  | 'invoice_action_mark_paid'
  | 'invoice_drawer_action_selected'
  | 'invoice_filters_updated'
  | 'invoice_filters_reset'
  | 'invoice_pagination_changed';

type InvoiceUiTelemetryPayload = Record<string, unknown>;

const CHANNEL = 'modalos:invoice-ui';

export function trackInvoiceUiEvent(event: InvoiceUiEvent, payload: InvoiceUiTelemetryPayload = {}): void {
  const data = {
    event,
    payload,
    at: new Date().toISOString(),
  };

  try {
    window.dispatchEvent(new CustomEvent(CHANNEL, { detail: data }));
  } catch {
    // Ignore if CustomEvent is unavailable.
  }

  try {
    // Console-safe fallback for local/dev operator troubleshooting.
    if (typeof window !== 'undefined' && (window as any).__MODAL_INVOICE_DEBUG__ === true) {
      // eslint-disable-next-line no-console
      console.debug('[invoice-ui]', data);
    }
  } catch {
    // Ignore telemetry fallback failures.
  }
}
